export const CHAT_READ_MODES = {
  latest: 'latest',
  beginning: 'beginning',
}
